import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Fade,
  Grid,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Menu,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { format, parse } from 'date-fns';
import BeneficiarioApi from '../../api/BeneficiarioApi.js';
import GuiaApi from '../../api/GuiaApi.js';
import TipoAtendimentoApi from '../../api/TipoAtendimentoApi.js';
import { withAuditoria } from '../../contexts/AuditoriaContext.jsx';
import { withLoading } from '../../contexts/LoadingContext.jsx';
import { withSnackbar } from '../../contexts/SnackbarContext.jsx';
import AttachFileIcon from '@material-ui/icons/AttachFile';

import ButtonAlertas from './ButtonAlertas.jsx';
import ButtonAnexos from './ButtonAnexos.jsx';
import ButtonGlosas from './ButtonGlosas.jsx';

import Autorenew from '@material-ui/icons/Autorenew';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import OpenInNew from '@material-ui/icons/OpenInNew';
import ButtonHistoricoGuia from './ButtonHistoricoGuia.jsx';
import MenuListGuia from './MenuListGuia.jsx';
import Utils from './Utils.js';

import { LinearProgress } from '@material-ui/core';
import CarenciaApi from '../../api/CarenciaApi.js';
import ElementoApi from '../../api/ElementoApi.js';
import AlertDialogSlide from './AlertDialogSlide.jsx';
import AlertDialogSlideGlosa from './AlertDialogSlideGlosa.jsx';
import DialogErrosValidacao from './DialogErrosValidacao.jsx';
import DrawerGuiaOriginal from './DrawerGuiaOriginal.jsx';
import DrawerGuiaSolicitacao from './DrawerGuiaSolicitacao.jsx';
import FormDialogCarencia from './FormDialogCarencia.jsx';
import LinearProgressBlockScreen from './LinearProgressBlockScreen.jsx';
import VariantSnackbar from './VariantSnackbar.jsx';
import PainelElementosRecurso from './PainelElementosRecurso.jsx';
import FormDialogAnexarArquivos from './FormDialogAnexarArquivos.jsx';
import FormDialogElementosPermissaoTroca from '../arquivosXML/FormDialogElementosPermissaoTroca.jsx';

const styles = theme => ({
  guiaContainer: {
    display: 'block',
    overflow: 'auto',
    flexGrow: 1,
    paddingBottom: theme.spacing(4),
    marginBottom: theme.spacing(1)
  },
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(1)
  },
  iconParecer: {
    fontSize: 14,
    marginRight: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: 11,
  },
  labelDadosInternacao: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    marginTop: theme.spacing(1),
  },
  labelDetalhe: {
    fontSize: 11,
    fontWeight: 'bold'
  },
  labelMotivoRecurso: {
    // display: 'inline',
    color: theme.palette.secondary.main,
    // marginTop: theme.spacing(4),
    fontSize: 11,
  },
  labelDetalheParecer: {
    fontSize: 11,
    fontWeight: 'bold',
    maxWidth: theme.spacing(40),
  },
  selectTipoAtendimento: {
    marginTop: theme.spacing(-2.8),
  },
  buttonParecer: {
    color: theme.palette.text.secondary,
    fontSize: 11,
    marginTop: theme.spacing(-1),
  },
  gridItemGuia: {
    marginRight: theme.spacing(0),
    minWidth: theme.spacing(32),
    maxWidth: theme.spacing(32),
  },
  gridItemGuiaLarge: {
    marginRight: theme.spacing(0),
    minWidth: theme.spacing(64),
    maxWidth: theme.spacing(64),
  },
  buttonAcoes: {
  }, 
  invisible: {
    display: 'none',
  },
});

class GuiaRecurso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      guia: undefined,
      carencias: [],
      isDetalhesCarregado: false,
      elementos: [],
      isElementosCarregado: false,
      openCarencias: false,
      guiaOriginal: {},
      guiasSolicitacao: [],
      detalhesGuia: {},
      operacao: {
        clickedButton: '',
        dialog: {
          open: false,
          title: '',
          message: '',
        },
      },
      openDialogGlosaGuia: false,
      dialogOpenErrosValidacao: false,
      dialogContent: [],
      dialogTitle: [],
      // expanded: false,
      anchorElVertMenu: null,
      snackOpen: false,
      guiasSolicitacaoOpen: false,
      openDialogHistorico: false,
      tituloFormDialog: '',
      tiposDeAtendimento: [],
      desTipoAtendimentoSelected: undefined,
      codTipoAtendimentoSelected: undefined,
      codTipoAtendimentoPrev: undefined,
      edicaoTipoAtendimento: false,

      caraterSolicitacao: [],
      codCaraterSolicitacaoSelected: undefined,
      desCaraterSolicitacaoSelected: undefined,
      codCaraterSolicitacaoPrev: undefined,
      edicaoCaraterSolicitacao: false,

      edicaoParecer: false,
      txtParecer: '',
      txtParecerButton: '',
      anchorElVertMenu: null,
      openCarencias: false,

      elementosSelecionados: 0,
      openDialogUpload: false,

      openDialogElementosPermissaoTroca: false,
      openDialogVerGuiaOriginal: false
    };
  }

  elementoApi = new ElementoApi();
  guiaApi = new GuiaApi();
  carenciaApi = new CarenciaApi();
  utils = new Utils();
  guiaApi = new GuiaApi();
  tipoDeAtendimentoApi = new TipoAtendimentoApi();
  beneficiarioApi = new BeneficiarioApi();


  componentDidMount = async () => {
    if (this.props.guia !== undefined) {

      const guiaSelecionada = this.props.guia;
      const carencias = await this.consultarCarencias(guiaSelecionada.numCarteiraTst) || [];
      const newElementos = await this.consultarElementosDaGuia(guiaSelecionada) || [];
      //const newElementos = this.props.guia.elementos;
      const newDetalhesGuia = await this.consultarDetalhesGuia(guiaSelecionada) || {};
      const tiposDeAtendimento = await this.tipoDeAtendimentoApi.consultarTiposAtendimento();
      const caraterSolicitacao = await this.tipoDeAtendimentoApi.consultarCaraterSolicitacao();
      
      for (let i = 0; i < newElementos.length; i++) {
        newElementos[i].glosas = newElementos[i].elementoOriginalDTO.glosas;
      }
        this.setState({
        guia: guiaSelecionada,
        carencias: carencias,
        detalhesGuia: newDetalhesGuia,
        codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
        codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,

        caraterSolicitacao: caraterSolicitacao,
        codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
        desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
        codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,

        txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
        txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
        isDetalhesCarregado: true,
        tiposDeAtendimento: tiposDeAtendimento,
        elementos: newElementos,
        isElementosCarregado: true,
      });
    }
  }

  consultarElementosDaGuia = async ({ codLoteGuia, codGuia }) => {
    const newElementos = await this.elementoApi.consultarElementosDaGuiaRecurso(codLoteGuia, codGuia);
    return newElementos || [];
  }

  consultarDetalhesGuia = async ({ codLoteGuia, codGuia, codTipoGuia }) => {
    const detalhesGuia = await this.guiaApi.consultarDetalhesGuia(codGuia, codLoteGuia, codTipoGuia);
    return detalhesGuia || {};
  }

  consultarCarencias = async (numMatricula) => {
    const carencias = await this.carenciaApi.consultarPorCarteira(numMatricula);
    return carencias || [];
  }

  componentDidUpdate = async (prevProps, prevState) => {

    if (this.props.guia !== undefined) {
      if (prevProps.codGuia !== this.props.codGuia) {
        let guiaSelecionada = this.props.guia;
        this.setState({
          guia: guiaSelecionada, elementos: [],
          isElementosCarregado: false,
          detalhesGuia: {},
          isDetalhesCarregado: false,
          edicaoCaraterSolicitacao: false,
          edicaoTipoAtendimento: false,
          edicaoParecer: false
        });
      }
    }

    if (prevState.guia !== undefined) {

      if (prevState.guia.codGuia !== this.state.guia.codGuia) {
        this.props.showLoading(`Carregando guia ${this.state.guia.numGuiaPrestador}..`);
        let carencias = await this.consultarCarencias(this.state.guia.numCarteiraTst);
        let newElementos = await this.consultarElementosDaGuia(this.state.guia);
        let newDetalhesGuia = await this.consultarDetalhesGuia(this.state.guia);
        this.setState({
          elementos: newElementos,
          isElementosCarregado: true,
          detalhesGuia: newDetalhesGuia,
          codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
          codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,
          codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
          desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
          codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,
          txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
          txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
          isDetalhesCarregado: true,
          carencias: carencias
        });
        this.props.hideLoading();
      }
      
      if (prevState.guia.valTotalLiberado !== this.state.guia.valTotalLiberado ||
          prevState.guia.valTotalGlosado !== this.state.guia.valTotalGlosado) {
            this.props.showLoading(`Carregando guia ${this.state.guia.numGuiaPrestador}..`);
            let carencias = await this.consultarCarencias(this.state.guia.numCarteiraTst);
            let newElementos = await this.consultarElementosDaGuia(this.state.guia);
            let newDetalhesGuia = await this.consultarDetalhesGuia(this.state.guia);
            this.setState({
              elementos: newElementos,
              isElementosCarregado: true,
              detalhesGuia: newDetalhesGuia,
              codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
              codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,
              codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
              desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
              codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,
              txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
              txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
              isDetalhesCarregado: true,
              carencias: carencias
            });
            this.props.hideLoading();
      }
        
      if (prevState.guia.qtdeElementosJaAuditados !== this.state.guia.qtdeElementosJaAuditados) {
        this.props.showLoading(`Carregando guia ${this.state.guia.numGuiaPrestador}..`);
        let carencias = await this.consultarCarencias(this.state.guia.numCarteiraTst);
        let newElementos = await this.consultarElementosDaGuia(this.state.guia);
        let newDetalhesGuia = await this.consultarDetalhesGuia(this.state.guia);
        this.setState({
          elementos: newElementos,
          isElementosCarregado: true,
          detalhesGuia: newDetalhesGuia,
          codTipoAtendimentoSelected: newDetalhesGuia.codTipoAtendimento,
          codTipoAtendimentoPrev: newDetalhesGuia.codTipoAtendimento,
          codCaraterSolicitacaoSelected: newDetalhesGuia.codCaraterSolicitacao,
          desCaraterSolicitacaoSelected: newDetalhesGuia.desCaraterSolicitacao,
          codCaraterSolicitacaoPrev: newDetalhesGuia.codCaraterSolicitacao,
          txtParecer: newDetalhesGuia.txtParecerAuditoria === null ? '' : newDetalhesGuia.txtParecerAuditoria,
          txtParecerButton: newDetalhesGuia.txtParecerAuditoria,
          isDetalhesCarregado: true,
          carencias: carencias
        });
        this.props.hideLoading();
      }
    }
  }

  updateGuia = async () => {
    const newGuiaSelecionada = await this.guiaApi.consultarGuia(this.state.guia.codLoteGuia, this.state.guia.codGuia);
    const newElementos = await this.consultarElementosDaGuia(newGuiaSelecionada);
    this.setState({ guia: newGuiaSelecionada, elementos: newElementos });
  }

  atualizarQtdeElementosSelecionados = (qtde) => {
    this.setState({elementosSelecionados: qtde});
  }

  handleCloseDialogErrosValidacao = async () => {
    this.setState({ dialogOpenErrosValidacao: false });
    await this.updateGuia();
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  conselhoProfissional = (input) => {
    if (input !== undefined && input !== null) {
      var inicio = input.indexOf('(');
      var fim = input.indexOf(')');
      if (inicio && fim) {
        return input.substring(inicio + 1, fim);
      } else {
        return input;
      }
    }
  }

  abrirTelaAnexos = () => {
    this.setState({openDialogUpload: true, 
      tituloFormDialog: this.props.modoEdicaoGuia ? 'Anexar Arquivos - Guia ' + this.state.guia.codGuia 
                                                  : 'Anexos da Guia ' + this.state.guia.codGuia });
  }
  handleDialogAnexosClose = async () => {
    this.setState({openDialogUpload: false});
  }
  onOperacaoFinalizadaAnexos = async () => {
    const newGuiaSelecionada = await this.guiaApi.consultarGuia(this.state.guia.codLoteGuia, this.state.guia.codGuia);
    this.setState({ guia: newGuiaSelecionada });
  }
  handleCloseElementosPermissaoTroca = () => {
    this.setState({openDialogElementosPermissaoTroca: false});
  }
  handleClickPermissaoTrocaItem = () => {
    this.setState({openDialogElementosPermissaoTroca: true});
  }
  handleClickVerGuiaOriginal = async () => {
    this.props.showLoading('Carregando guia original..');
    const guiaOriginal = await this.guiaApi.consultarGuiaOriginal(this.props.guia.codGuiaRecorrida, 0);
    this.setState({ guiaOriginal: guiaOriginal, openDialogVerGuiaOriginal: true });
    this.props.hideLoading();
  }  
  handleCloseVerGuiaOriginal = () => {
    this.setState({openDialogVerGuiaOriginal: false});
  }
  render() {
    const { classes, readOnly, emAuditoria, modoEdicaoGuia } = this.props;

    const { guia, isDetalhesCarregado, detalhesGuia, detalhesGuiaOriginal, isElementosCarregado } = this.state;
    
    return (
      guia !== undefined ?
        <React.Fragment>
          <div className={classes.guiaContainer}>
            {isDetalhesCarregado && (detalhesGuia !== undefined || detalhesGuiaOriginal !== undefined) && emAuditoria ?
              <div className={classes.root}>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                  >
                    <Grid container direction="row" justifyContent='space-between' alignItems='center'>
                      <Grid item>
                        <Typography variant='h6'>
                          {guia.qtdeElementosJaAuditados && guia.qtdeElementos ? guia.qtdeElementosJaAuditados + '/' + guia.qtdeElementos : ''} • {guia.nomeBeneficiario} • {guia.numCarteiraTst}
                          <Typography inline fontStyle='italic' variant='caption'>{'  ' + format(guia.dtaRecebimento, 'DD/MM/YYYY')}</Typography>
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid
                      container
                      direction='row'
                      spacing={4}
                      justifyContent='flex-start'
                      alignItems='flex-start'>
                      {guia.numGuiaPrestador || guia.numGuiaOperadora || guia.txtSenhaAutorizacao ?
                        <Grid item >
                          <Typography className={classes.label}>Nº Guia Prestador</Typography>
                          <Typography variant='button' title='Número da Guia do Prestador'>{guia.numGuiaPrestador}</Typography>
                          <Typography className={classes.label}>Nº Guia Operadora</Typography>
                          <Typography variant='button' title='Número da Guia da Operadora'>{guia.numGuiaOperadora}</Typography>
                          {guia.txtSenhaAutorizacao &&
                            <>
                              <Typography className={classes.label}>Senha: </Typography>
                              <Typography variant='button' title='Senha de Autorização'>{guia.txtSenhaAutorizacao}</Typography>
                            </>
                          }
                        </Grid>
                        : null}
                      <Grid item>
                        <Typography className={classes.label}>Valor processado</Typography>
                        <Box color="text.primary"><Typography>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(guia.valTotalProcessado)}</Typography></Box>
                        <Typography className={classes.label}>Valor glosado</Typography>
                        <Box color="warning.main"><Typography>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(guia.valTotalGlosado)}</Typography></Box>
                        <Typography className={classes.label}>Valor liberado</Typography>
                        <Box color="info.main"><Typography>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(guia.valTotalLiberado)}</Typography></Box>
                      </Grid>
                      <Grid item className={classes.gridItemGuia}>
                        {detalhesGuia.nomSolicitante
                          || detalhesGuia.nomProfissionalSolicitante
                          || detalhesGuia.nomPrestadorExecutante
                          || detalhesGuia.nomProfissionalExecutante
                          || detalhesGuia.numCpfCnpjExecutante ?
                          <>
                            <Typography className={classes.label}>Profissional solicitante</Typography>
                            <Typography className={classes.labelDetalhe} variant='button' title='Profissional solicitante'>
                              {detalhesGuia.nomProfissionalSolicitante ? detalhesGuia.nomProfissionalSolicitante : 'Não informado'}
                            </Typography>
                            <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='Conselho Profissional'>
                              {detalhesGuia.numRegistroConselhoSolicitante ? detalhesGuia.numRegistroConselhoSolicitante + ' - ' + this.conselhoProfissional(detalhesGuia.nomConselhoSolicitante) + ' ' + detalhesGuia.codUfRegistroSolicitante : '-'}
                            </Typography>
                            {detalhesGuia.nomSolicitante ?
                              <>
                                <Typography className={classes.label}>Prestador solicitante</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Prestador Solicitante'>{detalhesGuia.nomSolicitante}</Typography>
                                <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='CPF/CNPJ'>{this.utils.cpfOuCnpj(detalhesGuia.numCpfCnpjSolicitante)}</Typography>
                              </>
                              : null}
                            {detalhesGuia.nomProfissionalExecutante ?
                              <>
                                <Typography className={classes.label}>Profissional executante</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Profissional executante'>{detalhesGuia.nomProfissionalExecutante && detalhesGuia.numRegistroConselhoExecutante ? detalhesGuia.nomProfissionalExecutante : 'Não informado'}</Typography>
                                <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='Conselho Profissional'>
                                  {detalhesGuia.nomProfissionalExecutante && detalhesGuia.numRegistroConselhoExecutante
                                    ? detalhesGuia.numRegistroConselhoExecutante + ' - ' + this.conselhoProfissional(detalhesGuia.nomConselhoExecutante) + ' ' + detalhesGuia.codUfRegistroExecutante : null}
                                </Typography>
                              </>
                              : null}
                            <>
                              <Typography className={classes.label}>Prestador executante</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title='Prestador executante'>
                                {detalhesGuia.nomPrestadorExecutante ? detalhesGuia.nomPrestadorExecutante : (detalhesGuia.nomExecutante ? detalhesGuia.nomExecutante : 'Não informado')}
                              </Typography>
                              <Typography style={{ fontStyle: 'italic', fontSize: 12 }} title='CPF/CNPJ'>{this.utils.cpfOuCnpj(detalhesGuia.numCnpjExecutante)}</Typography>
                            </>
                          </>
                          : null}
                      </Grid>
                      {detalhesGuia.desTipoAtendimento
                        ?
                        <Grid item className={classes.gridItemGuia}>
                          <>
                            <Typography className={classes.label}>Tipo atendimento</Typography>
                            { readOnly ? (
                              <Typography className={classes.labelDetalhe} variant='button' title='Tipo Atendimento'>
                                {detalhesGuia.desTipoAtendimento}
                              </Typography>)
                            :
                            <>
                              <br />
                              <TextField
                                select
                                className={classes.selectTipoAtendimento}
                                value={this.state.codTipoAtendimentoSelected !== undefined ? this.state.codTipoAtendimentoSelected : detalhesGuia.codTipoAtendimento}
                                InputProps={{
                                  name: 'codTipoAtendimentoSelected',
                                  sx: { fontSize: 10 },
                                  endAdornment: this.state.edicaoTipoAtendimento &&
                                    <InputAdornment position='end'>
                                      <IconButton
                                        color='primary'
                                        disabled={this.state.edicaoTipoAtendimento === false}
                                        title='Salvar Tipo de Atendimento...'
                                      >
                                        <CheckIcon />
                                      </IconButton>
                                      <IconButton
                                        color='secondary'
                                        disabled={this.state.edicaoTipoAtendimento === false}
                                        title='Fechar'
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </InputAdornment>,
                                }}
                              >
                                {this.state.tiposDeAtendimento.map((tipoAtendimento, idx) => {
                                  return (<MenuItem key={idx} value={tipoAtendimento.codTipoAtendimento}>{tipoAtendimento.desTipoAtendimento}</MenuItem>);
                                })}
                              </TextField>
                            </>
                            }

                            {detalhesGuia.dtaHoraAtendimento ?
                              <>
                                <Typography className={classes.label}>Data e hora de atendimento</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Data e hora de atendimento'>{format(detalhesGuia.dtaHoraAtendimento, 'DD/MM/YYYY')}</Typography>
                              </>
                              : null}
                            {detalhesGuia.desCaraterSolicitacao
                              ? <>
                                <Typography className={classes.label}>Caráter da Solicitação</Typography>
                                { readOnly ? (
                                  <Typography className={classes.labelDetalhe} variant='button' title='Tipo Atendimento'>
                                    {detalhesGuia.desCaraterSolicitacao}
                                </Typography>
                                ) : 
                              <>
                                <br />
                                <TextField
                                  select
                                  className={classes.selectTipoAtendimento}
                                  value={this.state.codCaraterSolicitacaoSelected !== undefined ? this.state.codCaraterSolicitacaoSelected : detalhesGuia.codCaraterSolicitacao}
                                  InputProps={{
                                    name: 'codCaraterSolicitacaoSelected',
                                    endAdornment: this.state.edicaoCaraterSolicitacao &&
                                      <InputAdornment position='end'>
                                        <IconButton
                                          color='primary'
                                          disabled={this.state.edicaoCaraterSolicitacao === false}
                                          title='Salvar Caráter da Solicitação...'
                                        >
                                          <CheckIcon />
                                        </IconButton>
                                        <IconButton
                                          color='secondary'
                                          disabled={this.state.edicaoCaraterSolicitacao === false}
                                          title='Fechar'
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                      </InputAdornment>,
                                  }}
                                >
                                  {this.state.caraterSolicitacao.map((carater, idx) => {
                                    return (<MenuItem key={idx} value={carater.id}>{carater.nome}</MenuItem>);
                                  })}
                                </TextField>
                              </>  
                              }
                              </>
                              : null}
                            {detalhesGuia.desTipoSaidaSpsadt
                              ? <>
                                <Typography className={classes.label}>Tipo de Saída</Typography>
                                <Typography className={classes.labelDetalhe} variant='button' title='Tipo de Saída'>{`Saída por ${detalhesGuia.desTipoSaidaSpsadt}`}</Typography>
                              </>
                              : null}
                          </>
                        </Grid>
                        : null}
                      <Grid item>
                        {detalhesGuia.desTipoConsulta
                          ? <>
                            <Typography className={classes.label}>Tipo da Consulta</Typography>
                            <Typography className={classes.labelDetalhe} variant='button' title='Tipo da Consulta'>{detalhesGuia.desTipoConsulta}</Typography>
                          </>
                          : null}
                        {detalhesGuia.desIndAcidente
                          ? <>
                            <Typography className={classes.label}>Tipo de Acidente</Typography>
                            <Typography className={classes.labelDetalhe} variant='button' title='Tipo de Acidente'>{detalhesGuia.desIndAcidente}</Typography>
                          </>
                          : null}
                      </Grid>
                      {detalhesGuia.dataHora
                        ?
                        <Grid item className={classes.gridItemGuia}>
                          {detalhesGuia.desCaraterSolicitacao &&
                            <>
                              <Typography className={classes.labelDadosInternacao}>DADOS DA INTERNAÇÃO:</Typography>
                              <Typography className={classes.label}>Caráter da Solicitação</Typography>
                              <br />
                              <TextField
                                select
                                className={classes.selectTipoAtendimento}
                                value={this.state.codCaraterSolicitacaoSelected !== undefined ? this.state.codCaraterSolicitacaoSelected : detalhesGuia.codCaraterSolicitacao}
                                InputProps={{
                                  name: 'codCaraterSolicitacaoSelected',
                                  endAdornment: this.state.edicaoCaraterSolicitacao &&
                                    <InputAdornment position='end'>
                                      <IconButton
                                        color='primary'
                                        disabled={this.state.edicaoCaraterSolicitacao === false}
                                        title='Salvar Caráter da Solicitação...'
                                      >
                                        <CheckIcon />
                                      </IconButton>
                                      <IconButton
                                        color='secondary'
                                        disabled={this.state.edicaoCaraterSolicitacao === false}
                                        title='Fechar'
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </InputAdornment>,
                                }}
                              >
                                {this.state.caraterSolicitacao.map((carater, idx) => {
                                  return (<MenuItem key={idx} value={carater.id}>{carater.nome}</MenuItem>);
                                })}
                              </TextField>
                            </>}
                          {detalhesGuia.txtTipoAcomodacao &&
                            <>
                              <Typography className={classes.label}>Tipo da Acomodação</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title=''>{detalhesGuia.txtTipoAcomodacao}</Typography>
                            </>
                          }
                          {detalhesGuia.txtTipoInternacao &&
                            <>
                              <Typography className={classes.label}>Tipo da Internação</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title='Tipo da Internação'>{detalhesGuia.txtTipoInternacao}</Typography>
                            </>
                          }{detalhesGuia.txtRegimeInternacao &&
                            <>
                              <Typography className={classes.label}>Regime da Internação</Typography>
                              <Typography className={classes.labelDetalhe} variant='button' title='Regime da Internação'>{detalhesGuia.txtRegimeInternacao}</Typography>
                            </>
                          }
                          <>
                            <Typography className={classes.label}>Data e hora</Typography>
                            <Box fontStyle="italic" >
                              <Typography variant="caption" title='Entrada'>{`${format(detalhesGuia.dataHora, 'DD/MM/YYYY HH:mm:ss')}`}</Typography>
                              <Typography variant="caption" title='Saída'>{` a ${format(detalhesGuia.dataHoraSaida, 'DD/MM/YYYY HH:mm:ss')}`}</Typography>
                            </Box>
                          </>
                        </Grid>
                        : null}
                      {detalhesGuia.desDiagnosticoPrincipal
                        ? <Grid item className={classes.gridItemGuia}>
                          <>
                            <Typography className={classes.label}>Diagnósticos</Typography>
                            <Typography className={classes.labelDetalhe} title='Diagnóstico Principal'>{detalhesGuia.desDiagnosticoPrincipal}</Typography>
                          </>

                          {detalhesGuia.desDiagnosticoSec1
                            ? <>
                              <Typography className={classes.label}>1º Diagnóstico secundário</Typography>
                              <Typography className={classes.labelDetalhe} title='1º Diagnóstico secundário'>{detalhesGuia.desDiagnosticoSec1}</Typography>
                            </>
                            : null}
                          {detalhesGuia.desDiagnosticoSec2
                            ? <>
                              <Typography className={classes.label}>2º Diagnóstico secundário</Typography>
                              <Typography className={classes.labelDetalhe} title='2º Diagnóstico secundário'>{detalhesGuia.desDiagnosticoSec2}</Typography>
                            </>
                            : null}
                          {detalhesGuia.desDiagnosticoSec3
                            ? <>
                              <Typography className={classes.label}>3º Diagnóstico secundário</Typography>
                              <Typography className={classes.labelDetalhe} title='3º Diagnóstico secundário'>{detalhesGuia.desDiagnosticoSec3}</Typography>
                            </>
                            : null}
                        </Grid>
                        : null}
                      {detalhesGuia.txtObservacao || detalhesGuia.txtMotivoRecurso
                        ? <Grid item className={classes.gridItemGuiaLarge}>
                          {detalhesGuia.txtObservacao
                            ? <>
                              <Typography className={classes.label}>Observação</Typography>
                              <Typography className={classes.labelDetalhe} title='Observação enviada pelo prestador'>{detalhesGuia.txtObservacao}</Typography>
                            </>
                            : null}

                          {detalhesGuia.txtMotivoRecurso
                            ? <>
                              <Typography className={classes.labelMotivoRecurso}>Motivo do Recurso</Typography>
                              <Typography className={classes.labelDetalhe} title='Motivo do Recurso'>{detalhesGuia.txtMotivoRecurso}</Typography>
                            </>
                            : null}
                        </Grid>
                        : null}
                      {detalhesGuia.nomSolicitante
                        || detalhesGuia.nomProfissionalSolicitante
                        || detalhesGuia.nomPrestadorExecutante
                        || detalhesGuia.nomProfissionalExecutante
                        || detalhesGuia.numCpfCnpjExecutante ?

                        <Grid item className={classes.gridItemGuiaLarge}>
                          {readOnly ? (
                          <>
                            <Button
                              size='small'
                              className={classes.buttonParecer}
                              disabled>
                              <EditIcon size='small' className={classes.iconParecer} />
                              Parecer da auditoria
                            </Button>
                            <Typography className={classes.labelDetalheParecer} title='Parecer da auditoria'>
                              {this.state.txtParecer}
                              </Typography>
                          </>)
                          :
                            <>
                            <Button
                            size='small'
                            className={classes.buttonParecer}
                            onClick={this.handleClickParecer}
                            disabled={!this.props.emAuditoria}>
                            <EditIcon size='small' className={classes.iconParecer} />
                            Parecer da auditoria
                          </Button>
                          <Typography className={classes.labelDetalheParecer} title='Parecer da auditoria'>{this.state.txtParecer}</Typography>

                          {this.state.edicaoParecer && this.props.emAuditoria &&
                            <TextField
                              error={this.state.txtParecer.length > 1000}
                              multiline
                              autoFocus
                              maxRows='8'
                              fullWidth
                              value={this.state.txtParecer}
                              onChange={this.handleChangeParecer}
                              helperText='(max. 1.000 caracteres)'
                              variant='filled'
                              InputProps={{
                                name: 'txtParecer',
                                maxLength: 1000,
                                endAdornment: <InputAdornment position='end'>
                                  <IconButton
                                    color='primary'
                                    title='Salvar Parecer...'
                                    disabled={this.state.txtParecer === '' || this.state.txtParecer.length > 1000}
                                    onClick={this.handleSaveParecer}
                                  >
                                    <CheckIcon />
                                  </IconButton>
                                  <IconButton
                                    color='secondary'
                                    title='Fechar'
                                    onClick={this.handleClickFecharEdicaoParecer}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </InputAdornment>,
                              }}
                            />
                          }
                            </>
                          }
                        </Grid>
                        : null}
                    </Grid>
                    <Grid>
                      <IconButton
                        color='primary'
                        title='Clique para Ver a Guia Original'
                        className={classes.buttonAcoes}
                        onClick={this.handleClickVerGuiaOriginal} 
                        >
                          <VisibilityIcon />
                      </IconButton>                      
                    </Grid>
                    <Grid>
                      <IconButton
                        color='primary'
                        title='Clique para Trocar Permissão de Troca de Item'
                        className={this.props.modoEdicaoGuia ? classes.invisible : classes.buttonAcoes}
                        onClick={this.handleClickPermissaoTrocaItem} 
                        >
                          <Autorenew />
                      </IconButton>                      
                    </Grid>
                    <Grid>
                    <IconButton
                      color='primary'
                      //disabled={this.state.elementosSelecionados <= 0 && this.state.guia.anexos.length <= 0}
                      title='Anexar/Visualizar Arquivos...'
                      onClick={this.abrirTelaAnexos}
                    >
                      <AttachFileIcon />
                    </IconButton>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </div>
              : readOnly ?
                null : <LinearProgress />
            }
            {isElementosCarregado && this.state.elementos !== undefined
              ? <PainelElementosRecurso
                loteSelecionado={this.props.loteSelecionado}
                elementos={this.state.elementos}
                onOperacaoRealizada={this.updateGuia}
                atualizarQtdeElementosSelecionados={this.atualizarQtdeElementosSelecionados}
                emAuditoria={emAuditoria}
                modoEdicaoGuia={modoEdicaoGuia}
                isGuiaSolicitacao={false} />
              : <LinearProgress />
            }
          </div>

          {this.state.dialogOpenErrosValidacao &&
            <DialogErrosValidacao
              open={this.state.dialogOpenErrosValidacao}
              handleClose={this.handleCloseDialogErrosValidacao}
              erros={this.state.dialogContent}
              titulo={this.state.dialogTitle}
            />}

        {this.state.openDialogVerGuiaOriginal &&
          <DrawerGuiaOriginal
            open={this.state.openDialogVerGuiaOriginal}
            guiaOriginal={this.state.guiaOriginal}
            handleClose={this.handleCloseVerGuiaOriginal}
          />}
        {this.state.openDialogElementosPermissaoTroca &&
        <FormDialogElementosPermissaoTroca
          open={this.state.openDialogElementosPermissaoTroca}
          handleClose={this.handleCloseElementosPermissaoTroca}
          titulo={'Permissão para Trocar Item'}
          codGuia={this.props.codGuia}
          codLoteGuia={this.props.loteSelecionado.codLoteGuia}
          />}        

          <VariantSnackbar
            vertical={'top'}
            horizontal={'right'}
            variant={'warning'}
            message={'Não foi encontrada uma guia de solicitação para esta senha'}
            open={this.state.snackOpen}
            duration={3000}
            handleClose={this.handleCloseSnackbar}
          />
        {this.state.openDialogUpload &&
          <FormDialogAnexarArquivos
            titulo={this.state.tituloFormDialog}
            modoEdicaoGuia={modoEdicaoGuia}
            arquivos={this.state.guia.anexos}
            codGuia={this.state.guia.codGuia}
            codLoteGuia={this.state.guia.codLoteGuia}
            handleSave={this.onOperacaoFinalizadaAnexos}
            open={this.state.openDialogUpload}
            handleClose={this.handleDialogAnexosClose} />}
        </React.Fragment>
        : <LinearProgressBlockScreen />
    );
  }
}
export default withAuditoria(withSnackbar(withLoading(withStyles(styles)(GuiaRecurso))));
